import { icons } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const SubtitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['02']};
  min-width: 0;
  overflow: hidden;
`

export const SubtitleText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`

export const ErrorIcon = styled(icons.ErrorSmall)`
  flex-shrink: 0;
  width: ${({ theme }) => theme.size.icon.small};
  height: ${({ theme }) => theme.size.icon.small};

  path {
    fill: ${({ theme }) => theme.color.feedback.danger.default};
  }
`
